<div class="user-area-wrapper" *ngIf="!isLoading">
  <opac-user-title [title]="'user.events.title' | translateByCustomerType: customerType.dbValue"></opac-user-title>

  <opac-no-results
    *ngIf="!userEvents?.monthEvents.length"
    [label]="'user.events.noEvents' | translate"
   >
    <opac-no-results-events slot="custom-svg"></opac-no-results-events>
    <opac-no-results-cta>
      {{ 'cta.learning.experience' | translate }}
      <opac-button type="secondary" (click)="exploreLearningExperiences()">
        {{ 'browse.learning.experience' | translate }}
      </opac-button>
    </opac-no-results-cta>
  </opac-no-results>

  <div class="carousel" *ngIf="userEvents?.showEvents && userEvents?.monthEvents.length">
    <ng-container *ngFor="let monthEvent of userEvents?.monthEvents; let indexEvent = index">
      <span class="carousel__month"> {{ monthEvent.month | uppercase }} </span>
      <ng-container *ngFor="let dayEvent of monthEvent.dayEvents">
        <div class="event-card" *ngIf="dayEvent?.events?.length" [tabIndex]="0">
          <div class="event-card__date-item">
            <span
              [id]="dayEvent.date"
              class="day scrolling-target"
              [ngClass]="{ 'day--current-day': isToday(dayEvent?.date) }">
              {{ dayEvent?.date | date: 'd' }}
            </span>
            <span
              class="week-day"
              [ngClass]="{
                    'week-day--current-day': isToday(dayEvent?.date)
                  }">
              {{ dayEvent?.date | date: 'EEEEEE' | uppercase }}
            </span>
          </div>
          <div class="event-card__container">
            <ng-container *ngFor="let event of dayEvent?.events">
              <user-event-item class="event-component" [userEvent]="event"></user-event-item>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="isLoading">
  <event-skeleton></event-skeleton>
  <opac-gradient></opac-gradient>
</ng-container>
